import React from 'react';
import { simpleGroupStatus, simplePrivateStatus, groupMemberStatus } from '../../utils/adminBookingStatus';

export function GroupMemberBadge({ status }) {
  const s = groupMemberStatus(status);
  return <span className={`badge badge-${s.badge}`}>{s.label}</span>;
}

export function GroupDepartureBadge({ tour }) {
  const s = simpleGroupStatus(tour);
  return <span className={`badge badge-${s.badge}`}>{s.label}</span>;
}

export function PrivateInquiryBadge({ status }) {
  const s = simplePrivateStatus(status);
  return <span className={`badge badge-${s.badge}`}>{s.label}</span>;
}

export function AdminPhaseBanner({ phase, className = '' }) {
  if (!phase) return null;
  const alertClass = phase.badge === 'success' ? 'success'
    : phase.badge === 'warning' ? 'warning'
      : phase.badge === 'secondary' ? 'secondary'
        : 'light';
  return (
    <div className={`admin-phase-banner alert alert-${alertClass} ${className}`.trim()} role="status">
      <span className={`badge badge-${phase.badge} mr-2`}>{phase.label}</span>
      {phase.hint && <span className="admin-phase-banner__hint">{phase.hint}</span>}
    </div>
  );
}
